import type { RegisterMutation } from 'generated/gql';
import { MutationType } from 'generated/gql';

export const mutationInputFields = {
  [MutationType.Administration]: 'administration',
  [MutationType.AppointDirector]: 'appointDirector',
  [MutationType.ArticleOfAssociation]: 'onboarding', // Reuse onboarding for now
  [MutationType.Attachment]: 'attachment',
  [MutationType.Conversion]: 'conversion',
  [MutationType.EndAdministration]: 'endAdministration',
  [MutationType.EndAttachment]: 'endAttachment',
  [MutationType.EndDirectorship]: 'endDirectorship',
  [MutationType.EndPledge]: 'endPledge',
  [MutationType.EndUbo]: 'endUbo',
  [MutationType.EndUsufruct]: 'endUsufruct',
  [MutationType.Incorporation]: 'incorporation',
  [MutationType.Issuance]: 'issuance',
  [MutationType.Liquidation]: 'liquidation',
  [MutationType.Onboarding]: 'onboarding',
  [MutationType.PayingUp]: 'payingUp',
  [MutationType.Pledge]: 'pledge',
  [MutationType.Transfer]: 'transfer',
  [MutationType.TrustConditions]: 'onboarding', // Reuse onboarding for now
  [MutationType.Ubo]: 'ubo',
  [MutationType.Usufruct]: 'usufruct',
  [MutationType.Withdrawal]: 'withdrawal',
} satisfies {
  [k in MutationType]: keyof RegisterMutation; // we new mutation types are added, this will trigger an error indicating that the new type is missing from the object.
};

export type MutationInputFields = typeof mutationInputFields;
export type MutationInputField = MutationInputFields[keyof MutationInputFields];

export const getMutationField = <Type extends MutationType>(mutationType: Type) =>
  mutationInputFields[mutationType];
